module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.3531fc02.svg";